module.exports = __webpack_public_path__ + "img/68.222ff48b.jpg";